const getDurationNotice = (duration: string | number, t: (key: unknown) => any, replacePlaceholders: (text: any, variables: any) => any) => {
    try {
        if (isNaN(Number(duration)) || duration === 'unlimited') {
            return t('unlimited_duration_notice')
        }

        return replacePlaceholders(t('days_duration_notice'), {
            days: Number(duration)
        })
    } catch (error) {
        return t('unlimited_duration_notice')
    }
}

export default getDurationNotice